/**
 *	
 */
define('_views/../../admin/_models/imageupload.js',[
	
],
function(
) {
	return Backbone.Model.extend({
		
		hash : '',

		initialize : function(options) {

			this.options = options;

			if(!this.options) {
				this.options = {};
			}

			// don't send PID to the server.
			this.unset('pid');
			this.unset('type');
			this.unset('message_id');

		},

		uploadInProgress: false,

		uploadComplete: false,

		/**
		 * Upload a file
		 * Called by content-editproject on file drop
		 * Uses proimises to keep all the async in line
		 * @param  {Obj} file File object
		 */
		uploadFile: function(file){

			if(this.uploadInProgress) {
				throw "UploadInProgressError";
			}

			if(this.uploadComplete) {
				throw "AlreadyUploadedError";
			}

			if(file === undefined) {
				file = this.get('file');
			}

			if(file === undefined) {
				throw "NoFileError";
			}

			if(
				/(\.|\/)(gif|jpe?g|png)$/i.test(file.type) == false || 
				/(\.|\/)(gif|jpe?g|png)$/i.test(file.name) == false
			){
				this.trigger('invalid-file', this);
				return false;
			}

			var safe_name = file.name.replace(/[#&?+,;"\'\\\^\ ]/g, '-');
				safe_name = safe_name.replace(/([^a-zA-Z0-9-_\.]+)/g, '');

			// convert file to generic blob so we can change the name
			file = new Blob([file], {type: file.type});
			file.name = safe_name;

			if(this.options.type === "favicon") {

				Promise.all([
					this.convertImageToFavicon(file)
				]).then(function(result) {
					
					s3_data = result[0];

					// Actually do the upload by saving the model
					this.doUpload();

				}.bind(this), function(errorMsg) {

					if(this.options.mid !== undefined) {

						// something went wrong while preparing for upload, but getS3Policy
						// already created a DB entry for this image. Make sure we remove that
						var image_model = new top.Cargo.o.model.image;

						image_model.set('id', this.options.mid);
						image_model.destroy();

					}

					// Failed to retrieve the proper s3 Policy
					// Force upload failure
					this.trigger('upload-error', this, errorMsg);
					this.trigger('upload-complete', this);

				}.bind(this));

			} else {

				// Run a promise on getting dimensions and getting the s3 policy
				// if both of these complete correctly, then upload the image
				Promise.all([
					this.getImageDimensions(file), 
					this.getS3Policy(file)
				]).then(function(result) {
					// Stupidly, promises return all data as an array
					var img = result[0];
					var s3_data = result[1];

					// Actually do the upload by saving the model, pass the image data
					this.doUpload(img);

				}.bind(this), function(errorMsg) {

					if(this.options.mid !== undefined) {

						// something went wrong while preparing for upload, but getS3Policy
						// already created a DB entry for this image. Make sure we remove that
						var image_model = new top.Cargo.o.model.image;

						image_model.set('id', this.options.mid);
						image_model.destroy();

					}

					// Failed to retrieve the proper s3 Policy
					// Force upload failure
					this.trigger('upload-error', this, errorMsg);
					this.trigger('upload-complete', this);

				}.bind(this));

			}


		},

		dataURItoBlob: function(dataURI) {

			// convert base64/URLEncoded data component to raw binary data held in a string
			var byteString;
			if (dataURI.split(',')[0].indexOf('base64') >= 0)
				byteString = atob(dataURI.split(',')[1]);
			else
				byteString = unescape(dataURI.split(',')[1]);

			// separate out the mime component
			var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to a typed array
			var ia = new Uint8Array(byteString.length);
			for (var i = 0; i < byteString.length; i++) {
				ia[i] = byteString.charCodeAt(i);
			}

			if(mimeString === "ico") {
				mimeString = 'image/x-icon';
			}

			return new Blob([ia], {type:mimeString});

		},

		/**
		 * Actually do the upload by saving the model data
		 * Accepts the HTML5 img object so we can store the image dimensions after upload success
		 * @param  {Obj} img HTML5 image object
		 */
		doUpload : function(img) {
			this.uploadInProgress = true;

			this.trigger('upload-before-start', this, this.get('file'));

			this.jqXHR = this.save({}, {
				formData: true
			});

			this.jqXHR.done(_.bind(function() {
				//console.log('upload-success', arguments, img);
				// Create a real image model and return it
				this.createAndReturnImageModel(img, this, this.jqXHR);
				
			}, this))
			.fail(_.bind(function() {

				var errorMsg;

				try {
					var response = JSON.parse(jqXHR.responseText);

					if(response.error) {
						errorMsg = response.error;
					}
				} catch(e) {

				};

				this.trigger('upload-error', this, errorMsg);
				this.trigger('upload-complete', this);

				delete this.jqXHR;

			}, this))
			.always(_.bind(function() {
				//console.log('upload-complete', arguments);
				this.uploadInProgress = false;
				this.uploadComplete = true;
			}, this));
		},

		/**
		 * Set this model data based on s3 policy
		 * @param {Obj} data s3 policy
		 * @param {Obj} file File object
		 */
		setModelData : function(data, file) {
			this.urlRoot = data.aws_post_url;
			this.options.mid = data.mid;
			this.set('key', data.aws_hash + '/' + file.name);
			this.set('acl', 'public-read');
			this.set('Content-Type', file.type);
			this.set('AWSAccessKeyId', data.aws_access_key);
			this.set('Policy', data.aws_policy);
			this.set('Signature', data.aws_signature);
			this.set('file', file);
		},

		/**
		 * Query the server for the s3 policy based on the file to be uploaded
		 * This method is async and uses promises to return
		 * @return {Promise} Obj - s3 policy
		 */
		getS3Policy : function(file) {
			
			var _this = this;

			return new Promise(function(resolve, reject) {
				$.post('/dispatch/images/getS3Policy', {
					"name": file.name, 
					"size": file.size, 
					"type": file.type,
					"pid" : _this.options.pid
				}, _.bind(function(data) {

					// Set the model with the policy and file data
					_this.setModelData(data, file);

					// Resolve the promise
					resolve(data);

				}, this), "json")
				.fail(_.bind(function(){

					// Fail the promise
					reject('Unable to reach the server');

				}, this));
			});
		},

		convertImageToFavicon : function(file) {

			var _this = this;

			return new Promise(function(resolve, reject) {

				var formData = new FormData();
				formData.append('file', file);

				$.ajax({
					url : '/dispatch/images/convertFavicon',
					type : 'POST',
					data : formData,
					processData: false,
					contentType: false,
					success : _.bind(function(data) {

						try {

							data = JSON.parse(data);

							var ico_blob = _this.dataURItoBlob(data.favicon_data);

							ico_blob.name = file.name.substr(0, file.name.lastIndexOf(".")) + ".ico";

							_this.setModelData(data, ico_blob);

							// Resolve the promise
							resolve(data);

						} catch(e) {
							reject('Unable to reach the server');
						}

						

					}, this),
					error: _.bind(function(){

						// Fail the promise
						reject('Unable to reach the server');

					}, this)
				});
			});

		},

		/**
		 * Read the dropped file and get the image dimensions using promises
		 * This method is async and uses promises.
		 * It depends on the HTML5 file loader to read dimensions
		 * @param  {Obj} file File upload
		 */
		getImageDimensions : function(file) {
			return new Promise(function(resolve, reject) {
				var fr = new FileReader;
		
				fr.onload = function() {
					var img = new Image;

					img.onload = function() {
						// Resolve the promise
						resolve(img);
					};

					img.onerror = function() {
						// unable to load image, reject
						reject('This file does not appear to be an image');
					};

					img.src = fr.result;
				};

				fr.readAsDataURL(file);
			});
		},

		createAndReturnImageModel : function(img, thismodel, jqXHR) {

			// top in case we're in backstage frame
			var image_model = new top.Cargo.o.model.image;

			var _this = this;

			if(img) {
				image_model.set('width', img.width);
				image_model.set('height', img.height);
			}

			image_model.set('file_size', thismodel.get('file').size);
			image_model.set('mid', this.options.mid);
			image_model.set('type', this.options.type);
			image_model.set('message_id', this.options.message_id);
			image_model.set('name', this.get('file')['name']);
			image_model.set('hash', this.get('key'));
			image_model.set('page_id', thismodel.options.pid);

			image_model.save({}, {
				success: function(model) {
					// TODO: NO, NO, NO: BAD AART.
					model.uploadData = thismodel.uploadData;

					_this.trigger('upload-success', model, jqXHR);
					_this.trigger('upload-complete', this, model);
				
					delete _this.jqXHR;

				}
			});

		},


		save: function(key, val, options) {

			var fileAttribute = 'file';

			// Variables
			var attrs, 
				attributes = this.attributes,
				_this = this;

			// Signature parsing - taken directly from original Backbone.Model.save
			// and it states: 'Handle both "key", value and {key: value} -style arguments.'
			if (key == null || typeof key === 'object') {
				attrs = key;
				options = val;
			} else {
				(attrs = {})[key] = val;
			}

			// Validate & wait options - taken directly from original Backbone.Model.save
			options = _.extend({validate: true}, options);
			if (attrs && !options.wait) {
				if (!this.set(attrs, options)) return false;
			} else {
				if (!this._validate(attrs, options)) return false;
			}

			// Merge data temporarily for formdata
			var mergedAttrs = _.extend({}, attributes, attrs);

			if (attrs && options.wait) {
				this.attributes = mergedAttrs;
			}

			if ( options.formData === true
				&& mergedAttrs[ fileAttribute ]
				&& (
					mergedAttrs[ fileAttribute ].toString() == "[object File]" ||
					mergedAttrs[ fileAttribute ].toString() == "[object Blob]")
				) {

				// Flatten Attributes reapplying File Object
				var formAttrs = _.clone( mergedAttrs ),
					fileAttr = mergedAttrs[ fileAttribute ];
				formAttrs = this._flatten( formAttrs );
				formAttrs[ fileAttribute ] = fileAttr;

				// Converting Attributes to Form Data
				var formData = new FormData();
				_.each( formAttrs, function( value, key ){
					if (value instanceof FileList || (key === _this.fileAttribute && value instanceof Array)) {
						_.each(value, function(file) {
							formData.append( key, file );
						});
					}
					else {
						formData.append( key, value );
					}
				});

				// Set options for AJAX call
				options.data = formData;
				options.processData = false;
				options.contentType = false;

				// Handle "progress" events
				if (!options.xhr) {
					options.xhr = function(){
						var xhr = Backbone.$.ajaxSettings.xhr();
						xhr.upload.addEventListener('progress', function(){
							_this.trigger( 'upload-progress', _this, event);
						}, false);
						return xhr
					}
				}
			}

			// Resume back to original state
			if (attrs && options.wait) this.attributes = attributes;

			// Continue to call the existing "save" method
			return Backbone.Model.prototype.save.call(this, attrs, options);

		},

		createImageElementFromFile: function(file){

			if(file === undefined) {
				var file = this.get('file');
			}

			if(file === undefined || (file.toString() !== "[object File]" && file.toString() !== "[object Blob]")) {
				return false;
			}

			var imgEl = $('<img src="" border="0" width="" height="" width_o="" height_o="" src_o="" caption=""/>')[0];

			imgEl.addEventListener('load', function(){

				imgEl.setAttribute('width_o', imgEl.naturalWidth);
				imgEl.setAttribute('height_o', imgEl.naturalHeight);

				var defaultImageWidth = parseInt(Cargo.Model.DisplayOptions.get('image_width'));

				if(isNaN(defaultImageWidth) === false){
					imgEl.setAttribute('width', imgEl.naturalWidth);
					imgEl.setAttribute('height', imgEl.naturalHeight);
				}

				window.URL.revokeObjectURL(file);

			});

			imgEl.src = URL.createObjectURL(file);

			imgEl.style.maxWidth = Cargo.Model.DisplayOptions.GetImageWidth() + 'px';
			imgEl.style.height = 'auto';

			return imgEl;
		},

		// _ FlattenObject gist by "penguinboy".  Thank You!
		// https://gist.github.com/penguinboy/762197
		// NOTE for those who use "<1.0.0".  The notation changed to nested brackets
		_flatten: function flatten( obj ) {
			var output = {};
			for (var i in obj) {
				if (!obj.hasOwnProperty(i)) continue;
				if (typeof obj[i] == 'object') {
					var flatObject = flatten(obj[i]);
					/*for (var x in flatObject) {
						if (!flatObject.hasOwnProperty(x)) continue;
						output[i + '[' + x + ']'] = flatObject[x];
					}*/
				} else {
					output[i] = obj[i];
				}
			}
			return output;

		},
		
	});

});

